import { useContext, useEffect } from "react";
import { SmartContext } from "../../../../library/Core/SmartContext";
import useRecruiterDashboard from './useRecruiterDashboard';
import { Tooltip } from 'bootstrap';

const RecruiterLayoutComponent = (prop: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const { getRecruiterDashboardData } = useRecruiterDashboard();

    useEffect(() => {
        getRecruiterDashboardData();
    }, []);

    useEffect(() => {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('.defaultTooltip'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    })

    return (
        <div className="main flex-1">
            <section className="bg-red pt-3 pt-sm-5 pb-3 container-fluid" id="alumni_directory">
                <div className="max-1140 mx-auto">
                    <div className="row alumni-directory">
                        <div className="col-lg-12 alumni-directory-header">
                            <div className="alumni-directory-header_search">
                                <h2 data-aos-delay="300" className="font-35 font-600 text-white mb-3 mb-sm-0  me-3 ">Recruiters Dashboard - <span className="font-300">Recruiter's Stats</span> <i className="bi bi-info-circle-fill defaultTooltip font-24" data-bs-toggle= 'tooltip' title='Overview of recruiter engagement, hiring activity, and compensation metrics.'></i></h2>                       
                            </div>
                    
                    
                        </div>
                    </div>
                    <div className="aldir_scroll myCampus active">
                            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5">
                            <div className="col mb-4 aldir_box">
                                <div className="bg-white rounded alumni-directory-block h-100 position-relative" data-aos-delay="900">
                                    <div className="number font-28 font-600 d-flex justify-content-between align-items-center">
                                        {state.data?.reportData?.dashboardCounts?.confirmedRecruiter || 0} 
                                        <i className="bi bi-info-circle-fill defaultTooltip font-16 position-absolute top-10 right-10" data-bs-toggle= 'tooltip' title='Number of recruiters who have confirmed their participation in hiring.'></i>
                                        {/* <a href="javascript:;" className="icon-right-arrow font-14 font-600 text-decoration-none text-dark-blue"></a> */}
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div className="font-16 font-500 flex-1">
                                            Confirmed   <br />Recruiter
                                        </div>
                                        <div className="alumni-directory-img me-3 mb-3">
                                            <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/confirmed-recruiters.svg`} className="img-fluid" width="54" alt="Confirmed Recruiter" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col mb-4 aldir_box">
                                <div className="bg-white rounded alumni-directory-block h-100 position-relative" data-aos-delay="600">
                                    <div className="number font-28 font-600 d-flex justify-content-between align-items-center">
                                        {state.data?.reportData?.dashboardCounts?.totalCompanies || 0}
                                        <i className="bi bi-info-circle-fill defaultTooltip font-16 position-absolute top-10 right-10" data-bs-toggle= 'tooltip' title='Total number of companies associated with recruiters on the platform.'></i>
                                        {/* <a href="javascript:;" className="icon-right-arrow font-14 font-600 text-decoration-none text-dark-blue"></a> */}
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div className="font-16 font-500 flex-1">
                                            Total   <br />Companies
                                        </div>
                                        <div className="alumni-directory-img me-3 mb-3">
                                            <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/group-91019.svg`} className="img-fluid" width="54" alt="Total Companies" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col mb-4 aldir_box">
                                <div className="bg-white rounded alumni-directory-block h-100 position-relative" data-aos-delay="1200">
                                    <div className="number font-28 font-600 d-flex justify-content-between align-items-center">
                                        {state.data?.reportData?.dashboardCounts?.totalRolesForHiring || 0}
                                        <i className="bi bi-info-circle-fill defaultTooltip font-16 position-absolute top-10 right-10" data-bs-toggle= 'tooltip' title='Total number of distinct job roles recruiters are hiring for.'></i>
                                        {/* <a href="javascript:;" className="icon-right-arrow font-14 font-600 text-decoration-none text-dark-blue"></a> */}
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div className="font-16 font-500 flex-1">
                                            Total Roles   <br />Hiring For
                                        </div>
                                        <div className="alumni-directory-img me-3 mb-3">
                                            <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/recruiter-briefcase.svg`} className="img-fluid" width="47" alt="Total Roles Hiring For" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col mb-4 aldir_box">
                                <div className="bg-white rounded alumni-directory-block h-100 position-relative" data-aos-delay="1500">
                                    <div className="number font-28 font-600 d-flex justify-content-between align-items-center">
                                        {state.data?.reportData?.dashboardCounts?.prospectiveStudents || 0}
                                        <i className="bi bi-info-circle-fill defaultTooltip font-16 position-absolute top-10 right-10" data-bs-toggle= 'tooltip' title='Number of students currently being considered by recruiters.'></i>
                                        {/* <a href="javascript:;" className="icon-right-arrow font-14 font-600 text-decoration-none text-dark-blue"></a> */}
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div className="font-16 font-500 flex-1">
                                            Prospective   <br />Students
                                        </div>
                                        <div className="alumni-directory-img me-3 mb-3">
                                        <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/target-audience.svg`} className="img-fluid" width="58" alt="Prospective Students" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col mb-4 aldir_box">
                                <div className="bg-white rounded alumni-directory-block h-100 position-relative" data-aos-delay="2100">
                                    <div className="number font-28 font-600 d-flex justify-content-between align-items-center">
                                        {Number(state.data?.reportData?.dashboardCounts?.averageCtc).toFixed(2) || 0} ₹
                                        
                                        <i className="bi bi-info-circle-fill defaultTooltip font-16 position-absolute top-10 right-10" data-bs-toggle= 'tooltip' title='Average annual compensation offered by recruiters, shown in LPA or currency based on settings.'></i>
                                        {/* <a href="javascript:;" className="icon-right-arrow font-14 font-600 text-decoration-none text-dark-blue"></a> */}
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div className="font-16 font-500 flex-1 min94">
                                            Avg CTC<br/>  (LPA)
                                        </div>
                                        <div className="alumni-directory-img me-3 mb-3">
                                            <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/money.svg`} className="img-fluid" width="58" alt="Avg CTC" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                </div>
            </section>

            <section className="alumni_directory_details px-3 px-sm-3 px-md-0">
                <div className="container max-1140 pt-3 pt-sm-5 px-lg-0 pb-4 overflow-hidden myCampus active">
                    <h2 className="font-22 mb-3">Alumni Turned Recruiter Summary <i className="bi bi-info-circle-fill defaultTooltip font-16 " data-bs-toggle= 'tooltip' title='Summary of recruiters who are alumni and their hiring characteristics'></i></h2>
                    {prop.children}
                </div>
            </section>
        </div>
    );
};

export default RecruiterLayoutComponent;
